module.exports = {
  oneSignal: {
    appId: "4821a383-0193-46dc-84ef-58ddb37412a4",
  },
  mixPanel: {
    appId: "407bc6456a97df8074fdb0f1881d6d0e",
  },
  websocketUrl: 'https://wsdev.paperflite.com',
  intercom: {
    appID: "ize5om12",
  },
  smartlook: {
    projectKey: "6245dee640930a0e5ec2225103eea5988cb03413",
  },
};
